class BossTwo {
    constructor() {
        this.context = null;
        this.pageActive = {};

        TweenMax.to('.obj1-2-chr1 .eff', 1.5, { delay: .5, opacity: .5, yoyo: true, repeat: -1, ease: Power0.easeNone });
    }

    start(page) {
        this.pageActive[page] = true;
        this[page]();
        this.context.removeClass('animate-out');
    }

    reset(page) {
        this.pageActive[page] = false;
        this.context.removeClass('animate-in');
        this.context.addClass('animate-out');
        this.context.find('.active').removeClass('active');
    }

    bossTwo1() {
        this.context = $('.section-page__boss2');
        this.context.addClass('animate-in');
        this.context.find('.obj1-2-tit').addClass('active');
        this.context.find('.obj1-2-txt1').addClass('active');
        this.context.find('.obj1-2-chr1').addClass('active');
        this.context.find('.obj1-2-chr2').addClass('active');
    }
}

export default BossTwo;


// WEBPACK FOOTER //
// ./history/2017/171206_flamedragon/_src/js/page/bossTwo.js